'use client'

import ListingsStandard from '@component/card/listings/standard'
import SectionLayout from '@component/layout/section'
import SectionSwiper from '@component/layout/section/swiper'

export default function FeaturedListingsContent({
  data
}) {

  return (
    <SectionLayout title='Featured listings'>
      <SectionSwiper
        data={data}
        dataKey='id'
        slideClassName='py-12'
        swiperClassName='-my-12'
        Card={ListingsStandard}
      ></SectionSwiper>
    </SectionLayout>
  )
}